export type AysSpecialityId = '1000' | '1100' | '1200' | '1300' | '1400' | '1500' | '1600' | '1700' | '1800' | '1900'
  | '2000' | '2100' | '2200' | '2300' | '2400' | '2500' | '2600' | '2700' | '2800' | '2900'
  | '3000' | '3100' | '3200' | '3300' | '3400' | '3500' | '3600' | '3700' | '3800' | '3900'
  | '4000' | '4100' | '4200' | '4300' | '4400' | '4500' | '4600' | '4700' | '4800' | '4900'
  | '2401' | '2402' | '2403' | '2404' | '2405' | '2406' | '2407' | '2408' | '2409';

export class AysSpeciality {

  constructor(
    public specialityName: string,
    public specialityId: AysSpecialityId
  ) {
  }

  public parent(): AysSpeciality {
    const idParent = this.specialityId.slice(0, 3).concat('0');
    return AYS_SPECIALITIES.find(it => it.specialityId === idParent);
  }
}

export const AYS_SPECIALITIES: AysSpeciality[] = [
  new AysSpeciality('Allgemeinchirurgie', '1000'),
  new AysSpeciality('Allgemeinmedizin', '1100'),
  new AysSpeciality('Anästhesiologie', '1200'),
  new AysSpeciality('Arbeitsmedizin', '1300'),
  new AysSpeciality('Augenheilkunde', '1400'),
  new AysSpeciality('Biochemie', '1500'),
  new AysSpeciality('Diagnostische Radiologie', '1600'),
  new AysSpeciality('Frauenheilkunde und Geburtshilfe', '1700'),
  new AysSpeciality('Gefäßchirurgie', '1800'),
  new AysSpeciality('Hals-Nasen-Ohrenheilkunde', '1900'),
  new AysSpeciality('Haut- und Geschlechtskrankheiten', '2000'),
  new AysSpeciality('Herzchirurgie', '2100'),
  new AysSpeciality('Humangenetik', '2200'),
  new AysSpeciality('Hygiene und Umweltmedizin', '2300'),
  new AysSpeciality('Innere Medizin', '2400'),
  new AysSpeciality('Angiologie', '2401'),
  new AysSpeciality('Endokrinologie und Diabetologie', '2402'),
  new AysSpeciality('Gastroenterologie', '2403'),
  new AysSpeciality('Geriatrie', '2404'),
  new AysSpeciality('Hämatologie und Onkologie', '2405'),
  new AysSpeciality('Kardiologie', '2406'),
  new AysSpeciality('Nephrologie', '2407'),
  new AysSpeciality('Pneumologie', '2408'),
  new AysSpeciality('Rheumatologie', '2409'),
  new AysSpeciality('Mund-Kiefer-Gesichtschirurgie', '2500'),
  new AysSpeciality('Kinderheilkunde / Kinder- und Jugendmedizin', '2600'),
  new AysSpeciality('Kinderchirurgie', '2700'),
  new AysSpeciality('Pharmakologie und Toxikologie', '2800'),
  new AysSpeciality('Laboratoriumsmedizin', '2900'),
  new AysSpeciality('Mikrobiologie', '3000'),
  new AysSpeciality('Neurochirurgie', '3100'),
  new AysSpeciality('Neurologie', '3200'),
  new AysSpeciality('Neurologie und Psychiatrie', '3300'),
  new AysSpeciality('Neuropathologie', '3400'),
  new AysSpeciality('Nuklearmedizin', '3500'),
  new AysSpeciality('Orthopädie und Unfallchirurgie', '3600'),
  new AysSpeciality('Pathologie', '3700'),
  new AysSpeciality('Phoniatrie und Pädaudiologie', '3800'),
  new AysSpeciality('Physikalische und Rehabilitative Medizin', '3900'),
  new AysSpeciality('Plastische Chirurgie', '4000'),
  new AysSpeciality('Psychiatrie und Psychotherapie', '4100'),
  new AysSpeciality('Rechtsmedizin', '4200'),
  new AysSpeciality('Strahlentherapie', '4300'),
  new AysSpeciality('Thoraxchirurgie', '4400'),
  new AysSpeciality('Transfusionsmedizin', '4500'),
  new AysSpeciality('Urologie', '4600'),
  new AysSpeciality('Virologie', '4700'),
  new AysSpeciality('Viszeralchirurgie', '4800'),
];
